import { Tabs, cnMixSpace } from 'uikit';

import { useCallback, useMemo } from 'react';

import { CATALOG_VARIABLES_OTHER_TABS } from '../../constants';
import type { CatalogVariablesOtherTab } from '../../types';

type TCatalogVariablesOtherTabsProps = {
    value: CatalogVariablesOtherTab;
    onChange: (tab: CatalogVariablesOtherTab) => void;
};

export const CatalogVariablesOtherTabs = ({ value, onChange }: TCatalogVariablesOtherTabsProps) => {
    const activeTab = useMemo(
        () => CATALOG_VARIABLES_OTHER_TABS.find((item) => item.id === value) ?? CATALOG_VARIABLES_OTHER_TABS[0],
        [value],
    );

    const handleChange = useCallback(
        ({ value: nextTab }: { value: (typeof CATALOG_VARIABLES_OTHER_TABS)[number] }) => {
            onChange(nextTab.id);
        },
        [onChange],
    );

    return (
        <div className={cnMixSpace({ mH: 'xl', mB: 's' })}>
            <Tabs items={CATALOG_VARIABLES_OTHER_TABS} value={activeTab} onChange={handleChange} size="s" />
        </div>
    );
};

CatalogVariablesOtherTabs.displayName = 'CatalogVariablesOtherTabs';
